export default __webpack_public_path__ + "static/media/Oswald-Medium.3586ec85.ttf";